import { TableCell, TableRow } from '@mui/material';
import HelpTip from './HelpTip';

interface DataRowProps {
  label: string;
  value: React.ReactNode;
  bold?: boolean;
  tooltip?: string;
  color?: string;
}

// Non-breaking space glues the icon to the label's last word so a line break
// can only happen before the pair, never between the last word and the icon.
const NBSP = ' ';

const DataRow = ({ label, value, bold, tooltip, color }: DataRowProps) => (
  <TableRow sx={{ '&:last-child td': { borderBottom: 0 } }}>
    <TableCell sx={{ py: 0.5, fontSize: '0.8rem', fontWeight: bold ? 700 : 400 }}>
      {label}
      {tooltip && (
        <>
          {NBSP}
          <HelpTip title={tooltip} />
        </>
      )}
    </TableCell>
    <TableCell sx={{ py: 0.5, fontSize: '0.8rem', textAlign: 'right', fontWeight: bold ? 700 : 400, color: color || 'text.primary' }}>
      {value}
    </TableCell>
  </TableRow>
);

export default DataRow;
